<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2">Dedication</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_4">This novel is dedicated to the memory of James Donaghy, former vice-principal of Bishop Otter College whose shared, amused, fascination in bureaucratic secrecy sustained me through the interminable tedium which inspired its creation.</p>
<p class="block_5" id="calibre_pb_1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?ab4cb76a